import React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';

const BackdropLoader = ({ open = false, color = 'secondary', size = 30 }) => {
    return (
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={open}
        >
            <CircularProgress color={color} size={size} />
        </Backdrop>
    );
};

export default BackdropLoader;
